import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-28">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-29">
        <span className="text-lg md:text-xl font-bold text-navy-900 pr-8" data-id="element-30">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 text-gold shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-31" />
      </button>
      <AnimatePresence data-id="element-32">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-33">
            <p className="pb-6 text-slate-600 text-lg leading-relaxed" data-id="element-34">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito hablar inglés perfecto?',
    answer: 'No, la guía y el mercado objetivo es 100% hispano en USA.'
  }, {
    question: '¿Cuánto dinero necesito para empezar?',
    answer: 'Aparte de la guía, puedes empezar con la oferta de Shopify de $1 y unos $5 diarios para anuncios.'
  }, {
    question: '¿Tengo que ser experta en computadoras?',
    answer: 'Si sabes usar Facebook y enviar un email, puedes hacer esto.'
  }, {
    question: '¿Puedo hacerlo desde mi celular?',
    answer: 'Sí, el 90% del proceso se puede gestionar desde tu smartphone.'
  }, {
    question: '¿Qué pasa si no tengo una idea de producto?',
    answer: 'La guía incluye una lista de nichos calientes que se venden ahora mismo.'
  }];
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-38">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 md:p-8" data-id="element-39">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-40" />)}
        </div>
      </div>
    </section>;
}